<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title v-if="!question_id">{{ 'Add Question' | translate }}</v-card-title>
              <v-card-title v-if="question_id">{{ 'Edit Question' | translate }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row v-if="errors">
                        <v-col cols="12" sm="12" md="12">
                          <v-alert
                            dense
                            v-for="(v, k) in errors"
                            :key="k"
                            outlined
                            type="error"
                          >{{ k }} {{ v }}</v-alert>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            :label="'Question name' | translate"
                            v-model="question_name"
                            name="question_name"
                            autocomplete="off"
                            :rules="questionnameRules"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            :label="'Question text' | translate"
                            v-model="question_text"
                            name="question_text"
                            autocomplete="off"
                            :rules="questiontextRules"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            name="question_help_text"
                            v-model="question_help_text"
                            autocomplete="off"
                            :label="'Question Help Text' | translate"
                            :rules="questionhelptextRules"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>
                          </v-textarea>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6" md="6">
                          <v-autocomplete
                              v-model="question_type"
                              :items="questionType"
                              item-value="value"
                              item-text="text"
                              :label="'Question Type' | translate"
                              :rules="questionTypeRules"
                              outlined
                              chips
                              small-chips
                              required
                              :no-data-text="$t('No data available')"
                              >
                              <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                              </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                           <v-autocomplete
                              v-model="question_lang_label"
                              :items="questionLanguage"
                              item-value="value"
                              item-text="text"
                              :label="'Language' | translate"
                              :rules="questionLanguageRules"
                              outlined
                              chips
                              small-chips
                              required
                              :no-data-text="$t('No data available')"
                              >
                              <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                              </template>
                            </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <v-autocomplete
                              v-model="question_topics"
                              item-value="question_topic_id"
                              item-text="question_topic"
                              :items="questiontopicdata"
                              :label="'Question Topic' | translate"
                              :rules="questionTopicRules"
                              outlined
                              autocomplete="off"
                              chips
                              multiple
                              small-chips
                            >
                            <template v-slot:append-outer>
                              <v-btn large class="mt-n3 pt-4 pb-4 white--text" @click="showTopic" :color="primary_color">{{ 'Add Topic' | translate }}</v-btn>
                            </template>
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>
                            </v-autocomplete>
                        </v-col>

                          <v-col cols="12" v-show="show">
                            <v-text-field
                              outlined
                              :label="'Add Topic' | translate"
                              name="topic"
                              v-model="question_topic"
                              autocomplete="off"
                            >

                              <template v-slot:append-outer>
                                <v-btn large class="mt-n3 pt-4 pb-4 white--text" @click="addTopic" :color="primary_color">{{ 'Add' | translate }}</v-btn>
                              </template>
                            </v-text-field>
                          </v-col>

                          <v-col cols="12">
                            <v-alert
                              text
                              dense
                              type="error"
                              icon="mdi-alert"
                              close-text="Close Alert"
                              dismissible
                              v-model="topic_error_message"
                            >
                            {{ 'The Topic ' | translate}} <b>{{question_topic}} </b>{{' is already added. Please select from the list or add a new topic.' | translate}}
                            </v-alert>
                          </v-col>
                      </v-row>

                      <v-row>
                        <!-- <v-col cols="12" v-if="question_id !== null "> -->
                        <v-col cols="12">
                         <v-card-text class="pb-4 title" @click="add" style="cursor: pointer" >{{ 'Answers' | translate}}
                           <v-icon >mdi-plus-box</v-icon>
                        </v-card-text>   
                        </v-col>
                      </v-row>

                      <!-- <v-row v-if="question_id !== null "> -->
                      <v-row  v-for="(ans, i) in answers"
                            :key="i">
                        <v-col cols="9" :style="selectedFields">
                                <v-text-field
                                outlined
                                :label="'Answer' | translate"
                                v-model="ans.answer_text"
                                :rules="answerRules"
                                required
                                dense
                                ></v-text-field>
                        </v-col>
                         <v-col cols="2" :style="selectedFields">
                                <v-text-field
                                outlined
                                :label="'Points' | translate"
                                v-model="ans.answer_points"
                                :rules="answerPointRules"
                                type="number"
                                dense
                                ></v-text-field>
                        </v-col>

                         <v-col cols="1" :style="selectedFields">
                              <v-icon class="mt-n3 pt-4 pb-4" v-if="!ans.answer_id" @click="removekey(i)">mdi-delete</v-icon>
                              <v-icon class="mt-n3 pt-4 pb-4" v-if="ans.answer_id" @click="remove(i,ans.answer_id)">mdi-delete</v-icon>
                        </v-col>
                      </v-row>


                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                    </v-col>
                  </v-row>
                </v-form>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="question_id != ''"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="question_id"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>
            </v-container>
          </v-card>
       </v-col>
      </v-row>
    
      <v-overlay :value="showLoader">
          <v-layout row justify-center v-if="showLoader">
            <v-dialog v-model="showLoader" persistent fullscreen content-class="loading-dialog">
              <v-container fill-height>
                <v-layout row justify-center align-center>
                  <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
                </v-layout>
              </v-container>
            </v-dialog>
          </v-layout>
        </v-overlay>

    </v-container>
  </v-content>
</template>

<script>
import {
  ADD_QUESTION,
  RESET_STATE,
  FETCH_INDIVIDUAL_QUESTION,
  FETCH_QUESTION_TOPIC,
  ADD_QUESTION_TOPIC_DATA,
  UPDATE_QUESTION,
  DELETE_ANSWER
} from "@/store/actions.type";
import {  SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
import store from "@/store"
import { mapState } from "vuex"
import { mapGetters } from "vuex"
export default {
  name: "addeditQuestions",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(RESET_STATE);
    await store.dispatch(FETCH_QUESTION_TOPIC, "")
    if (to.params.id) {
      await store.dispatch(FETCH_INDIVIDUAL_QUESTION, to.params.id).then(resp => {
      if (resp.success) {
        store.commit(SET_LOADING, false)
        store.commit(SET_ROUTER_ENTER, false)
      }
    });
    }
    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE);
    next();
  },
  computed: {
    ...mapGetters(["individualquestion", 'questiontopicdata','currentUser','curLanguage']),
    ...mapState({
      errors: state => state.questions.questionerrors,
      curLanguage: state => state.translations.curLanguage,
    }),
    footertext(){
      return this.$t('Rows per page')
    },

    questionnameRules(){return [v => !!v || "Question name is required"]},
    questiontextRules(){return [v => !!v || "Question text is required"]},
    questionhelptextRules(){return [v => !!v || "Question help text is required"]},
    questionTopicRules(){ return [v => !!(v && v.length) || "At least one Question Topic is required"]},
    questionTypeRules(){ return [v => !!(v && v.length) || "Question Type is required"]},
    questionLanguageRules(){ return [v => !!(v && v.length) || "Language is required"]},
    questionType(){
      return [
          {value: 'single-select', text:this.$t('Single-select')},
          {value: 'multiple-select', text:this.$t('Multi-select')}
      ]
    },
    questionLanguage(){
      return [
          {value: 'de', text:this.$t('German')},
          {value: 'en', text:this.$t('English')}
      ]
    },
    answerRules(){return [v => !!v || "Answer is required"]},
    answerPointRules(){ 
      return [
        v => Number.isInteger(Number(v)) || "The value must be an integer number"
      ]
    },
  },
  created(){
    this.questiontopicdata.forEach((item)=> {
        this.topicDataNames.push({'question_topic':item.question_topic})
    })
  },
  mounted () {
    if(Object.keys(this.individualquestion).length > 0){
      this.question_id = this.individualquestion.question_id
      this.question_name = this.individualquestion.question_name
      this.question_text = this.individualquestion.question_text
      this.question_help_text  = this.individualquestion.question_help_text
      this.question_type  = this.individualquestion.question_type
      this.question_lang_label  = this.individualquestion.question_lang_label
      this.question_topics = this.individualquestion.question_topics

      this.individualquestion.answers.forEach((item)=> {
        this.answers.push({ 
          answer_id: item.answer_id,
          answer_text: item.answer_text,
          answer_points: item.answer_points
        })
      })

    }
    let company_meta  = JSON.parse(this.currentUser.company.company_meta)
    this.primary_color  = company_meta.primary_color    
  },
  data: function() {
    return {
      question_name:null,
      question_text:null,
      answers: [],
      question_id: null,
      question_type:null,
      question_lang_label:null,
      question_help_text: null,
      topicDataNames:[],
      primary_color: null,
      question_topics:[],
      question_topic:null,
      status: null,
      topic_error_message: false,
      show: false,
      showLoader: false,
      selectedFields:{
          'padding-bottom': '0',
          'padding-top': '0'
      },
    }
  },
  methods : {
    showTopic(){
      this.show=!this.show;
      this.topic_error_message = false;
      this.question_topic = "";
    },
    addTopic(){
      this.question_topic = this.question_topic.charAt(0).toUpperCase()+ this.question_topic.slice(1)
      this.questiontopicdata.forEach((item)=> {
        if(Object.values(item).includes(this.question_topic)){
          this.topic_error_message = true;
          this.show = false;
          return;
        }
      })
      if(!this.topic_error_message){
        this.showLoader = true
        this.$store.dispatch(ADD_QUESTION_TOPIC_DATA,{question_topic:this.question_topic.charAt(0).toUpperCase()+ this.question_topic.slice(1) }).then(response =>{
          if(response.hasOwnProperty('success') && response.success){
            store.dispatch(FETCH_QUESTION_TOPIC,'').then(()=>{
              this.question_topics.push(response.data.question_topic_id);
              this.question_topic=null
              this.show = false
              this.showLoader = false
              store.commit(SET_LOADING, false)
                this.topic_error_message=false;

            })
          }
          else{
            store.commit(SET_LOADING, false)
          }
        })
      }
    },
    add () {
        this.answers.push({ 
          answer_text: "",
          answer_points: "0"
        })
     },
     removekey (index) {
         this.answers.splice(index, 1)
     },
     remove (index,id) {
         this.answers.splice(index, 1)
         this.showLoader = true
         this.$store
          .dispatch(DELETE_ANSWER, id)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_LOADING, false)
              store.commit(SET_SNACKBAR, {status: true, message: 'Answer Removed Successfully'})
              this.showLoader = false
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
     },
    submit: function() {
      if (this.$refs.form.validate()) {
        let data = {
            question_id:this.question_id,
            question_name: this.question_name,
            question_text: this.question_text,
            question_help_text: this.question_help_text,
            question_type: this.question_type,
            question_lang_label: this.question_lang_label,
            question_topics: this.question_topics, 
            answers: this.answers, 
            _method: "post"
          };
        this.$store
          .dispatch(ADD_QUESTION, data )
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_LOADING, false)
              store.commit(SET_SNACKBAR, {status: true, message: 'Question created successfully'})
              // this.$router.push({ name: "questionedit" , params: { id: resp.data.question_id }});
              this.$router.push({ name: "questions"});
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    update: function() {
      if (this.$refs.form.validate()) {
        let data = {
            question_id:this.question_id,
            question_name: this.question_name,
            question_text: this.question_text,
            question_help_text: this.question_help_text,
            question_type: this.question_type,
            question_lang_label: this.question_lang_label,
            question_topics: this.question_topics, 
            answers: this.answers, 
            _method: "put"
          };

        this.$store
          .dispatch(UPDATE_QUESTION, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_LOADING, false)
              store.commit(SET_SNACKBAR, {status: true, message: 'Question updated successfully'})
              // this.$router.push({ name: "questionedit" , params: { id: resp.data.question_id }});
              this.$router.push({ name: "questions"});
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    }

  },
};
</script>
